import { t } from '@lingui/macro'
import { useMemo } from 'react'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Info } from '@/modules/appointment/components/info/Info'
import { capitalize, formatLocale } from '@/modules/shared/helpers/locale'
import { navigateMaps } from '@/modules/shared/helpers/navigation'
import { EncounterTimeInfo } from '../encounter-time-info/EncounterTimeInfo'

import type { Encounter } from '../../types/encounter.types'

type Props = {
  encounter?: Encounter
}

const EncounterInfo = ({ encounter }: Props) => {
  const theme = useTheme()

  const showAppointmentTime = useMemo<boolean>(() => {
    const hasNotes = encounter?.meta?.notes?.length

    return hasNotes === 0 && !encounter?.meta?.hiddenInApp
  }, [encounter])

  return (
    <FlexColumn gap={theme.UI.Spacing.Space3}>
      {encounter?.start ? (
        <>
          <Info
            icon={['fal', 'calendar']}
            info={[capitalize(formatLocale(new Date(encounter?.start), 'EEEE dd/MM/yyyy'))]}
            bold
          />
        </>
      ) : null}
      {showAppointmentTime && <EncounterTimeInfo encounter={encounter} />}
      {encounter?.meta?.location?.room ? (
        <Info
          icon={['fal', 'door-closed']}
          info={[
            t({
              id: 'encounter.detail.room',
              message: 'Kamer {room}',
              values: {
                room: encounter?.meta?.location?.room,
              },
            }),
          ]}
        />
      ) : null}

      {encounter?.meta?.location ? (
        <Info
          icon={['fal', 'location-pin']}
          info={[
            encounter?.meta?.location?.name,
            encounter?.meta?.location?.address?.street,
            encounter?.meta?.location?.address?.city,
          ]}
          onClick={() => navigateMaps(encounter.meta.location?.address)}
        />
      ) : null}
    </FlexColumn>
  )
}

export { EncounterInfo }
